import { ASSISTER_FILTER_VALIDATION_TYPES } from '@constants/actionTypes/entityActionTypes';

export const INITIAL_STATE = {
    exportBtnDisable : true,
    reassignBtnDisable : true
};

export default (state= INITIAL_STATE, action = {}) => {
    switch(action.type) { 
        case ASSISTER_FILTER_VALIDATION_TYPES.SET_EXPORT_BTN_STATE:
            return { ...state ,  exportBtnDisable : action.btnState.isDisable  };
        
        case ASSISTER_FILTER_VALIDATION_TYPES.SET_REASSIGN_BTN_STATE:
            return { ...state ,  reassignBtnDisable : action.btnState.isDisable  };
        default:
            return state;
    }
};